export default __webpack_public_path__ + "media/Seasoning-Seasoning.256a874c.png";